import React, { ReactElement } from 'react';

/**
 * フッターコンポーネント
 * @returns
 */
export function Footer(): ReactElement<void> {
  return (
    <footer className="l-footer">
      <div className="l-inner">
        <div className="foot-wrap">
          <small className="ft-co fsz-s">
            &copy; 2025 HumanSystem Co., Ltd.
          </small>
          <div className="ft-logo">
            <a href="https://humansystem.com">
              <i className="icon ic-logo"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
